import { RowSelectionState } from "@tanstack/react-table"
import {
  createContext,
  useContext,
  useState,
  ReactNode,
  FC,
  Dispatch,
  SetStateAction,
} from "react"

import type { BatchModalInfo } from "~/pages/SupplierPortal/TraceabilityRequests/Modals/BatchModal/BatchModal.tsx"

type BatchUpdateModalContextType = {
  isLoading: boolean
  setIsLoading: Dispatch<SetStateAction<boolean>>
  batchModalOpen: boolean
  batchModalInfo: BatchModalInfo | null
  setBatchModalInfo: Dispatch<SetStateAction<BatchModalInfo | null>>
  setBatchModalOpen: Dispatch<SetStateAction<boolean>>
  rowSelection: RowSelectionState
  setRowSelection: Dispatch<SetStateAction<RowSelectionState>>
}

export const BatchUpdateModalContext = createContext<
  BatchUpdateModalContextType | undefined
>(undefined)

export const useBatchUpdateModalContext = () => {
  const context = useContext(BatchUpdateModalContext)
  if (!context) {
    throw new Error(
      "useBatchUpdateModalContext must be used within a BatchUpdateModalProvider"
    )
  }
  return context
}

export const BatchUpdateModalProvider: FC<{ children: ReactNode }> = ({
  children,
}) => {
  const [batchModalOpen, setBatchModalOpen] = useState<boolean>(false)
  const [batchModalInfo, setBatchModalInfo] = useState<BatchModalInfo | null>(
    null
  )
  const [isLoading, setIsLoading] = useState<boolean>(false)
  const [rowSelection, setRowSelection] = useState<RowSelectionState>({})
  return (
    <BatchUpdateModalContext.Provider
      value={{
        isLoading,
        setIsLoading,
        setBatchModalInfo,
        batchModalOpen,
        setBatchModalOpen,
        batchModalInfo,
        rowSelection,
        setRowSelection,
      }}
    >
      {children}
    </BatchUpdateModalContext.Provider>
  )
}
